import React from 'react'
import AppLoading from '../../AppLoading'

const AuthenticatingPage = () => <AppLoading />

export default AuthenticatingPage
